import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {lightTheme} from '../../../libs/shared/ui/src/theme/light/lightTheme';
import {SettingsNavItemCommonStyleProps} from './settingsMenuCommonTypes';

interface NavItemStyleProps extends SettingsNavItemCommonStyleProps {
  $isActive: boolean;
}
const StyledNavItemTitleDiv = styled.div<NavItemStyleProps>`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
  color: ${(p) => (p.$isActive ? p.$theme.itemBold : p.$theme.item)};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: -2px;

  & > svg,
  & > div {
    margin-left: 6px;
  }
`;

interface SettingsNavItemTitleProps {
  isActive: boolean;
}
export const SettingsNavItemTitle: FC<SettingsNavItemTitleProps> = (props) => (
  <StyledNavItemTitleDiv $theme={lightTheme} $isActive={props.isActive}>
    {props.children}
  </StyledNavItemTitleDiv>
);
